export const theme = {
  colors: {
    background: '#FAFBFE',
    surface: '#FFFFFF',
    primary: '#4A90D9',
    primaryLight: 'rgba(74, 144, 217, 0.1)',
    primaryGlow: 'rgba(74, 144, 217, 0.3)',
    text: '#2C3E50',
    textSecondary: '#7F8C8D',
    border: 'rgba(74, 144, 217, 0.3)',
    borderHover: 'rgba(74, 144, 217, 0.6)',
    shadow: 'rgba(74, 144, 217, 0.15)',
  },
  fonts: {
    primary: "'Inter', 'Segoe UI', -apple-system, sans-serif",
    mono: "'JetBrains Mono', 'Fira Code', monospace",
  },
  sizes: {
    borderRadius: '16px',
    borderRadiusSmall: '8px',
    maxWidth: '1200px',
  },
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
  },
  transitions: {
    default: '0.3s ease',
    slow: '0.5s ease',
    spring: { type: 'spring' as const, stiffness: 300, damping: 20 },
  },
} as const;

export type Theme = typeof theme;

export const media = {
  mobile: `@media (max-width: ${theme.breakpoints.mobile})`,
  tablet: `@media (max-width: ${theme.breakpoints.tablet})`,
  desktop: `@media (max-width: ${theme.breakpoints.desktop})`,
} as const;
